<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.phone }}
        <br />
        {{ userStore.user.email }}
    </p>
    
    <p>
        {{ creditor.creditor_name }} <br />
        {{ creditor.address_line }} <br />
        {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
    </p>
    <p>
        <b>
            Re:	Request for student loan relief due to COVID-19 (coronavirus) pandemic
        </b>
    </p>
    <div class="page">
        <p class="letter-content">
            Loan number {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p class="letter-content">
            To {{ creditor.creditor_name }}:
        </p>
        <p class="letter-content">
            My full name is {{ userStore.user.firstname }} {{ userStore.user.lastname }}. My date of birth is {{ userStore.user.dob }}. My Social Security Number is {{ userStore.user.ssn }}. On 3/11/2020, the World Health Organization (“WHO”) designated the novel coronavirus COVID-19 as a pandemic. In a short period, in the US, over 41,939 cases and over 500 deaths been reported. Many companies and schools have closed due to COVID-19 cases or exposures. 
        </p>
        <p class="letter-content">
            I have suffered a substantial loss of income related to the COVID-19 pandemic. Unfortunately, I cannot make my student loan payments due to my loss of income. Please let me know if you will waive late fees, interest, or anything for some time. Please know that I intend to begin payments again as soon as I am financially able. Can you suspend my payment for up to twelve (12) months or as long as possible? Please refrain from any negative credit reporting during this hardship period of time. If negative reporting was made, please make my request retroactive to remove it. Please remove me or do not include me in any default status on my student loan. Kindly acknowledge in writing that my loan is deferred and until what date exactly. Please contact me if you need any additional information from me. Thank you.
        </p>
        <p class="letter-content">
            Sincerely, <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        },
    };
</script>